export function formatStorageBytes(bytes) {
  const n = Number(bytes) || 0
  if (n >= 1073741824) return `${(n / 1073741824).toFixed(0)} GB`
  if (n >= 1048576) return `${(n / 1048576).toFixed(0)} MB`
  return `${(n / 1024).toFixed(0)} KB`
}

export function effectivePlanFeatures(features, flags = {}) {
  const f = { ...(features || {}) }
  if (flags.hide_ai) {
    f.ai_enabled = false
    f.max_ai_tokens = 0
  }
  if (flags.hide_scheduler) {
    f.max_posts = 0
    f.max_accounts = 0
    f.analytics = false
  }
  return f
}

export function planFeatureList(plan, t, flags = {}) {
  const f = effectivePlanFeatures(plan?.features, flags)
  const items = []

  if (f.max_storage_bytes === -1) items.push(t('billing.features.unlimited_storage'))
  else if (f.max_storage_bytes) {
    items.push(t('billing.features.storage', { size: formatStorageBytes(f.max_storage_bytes) }))
  }

  if (f.max_canva_imports === -1) items.push(t('billing.features.unlimited_canva'))
  else if (f.max_canva_imports) {
    const key = f.max_canva_imports > 1 ? 'billing.features.canva_imports_plural' : 'billing.features.canva_imports'
    items.push(t(key, { count: f.max_canva_imports }))
  }

  if (f.api_enabled) items.push(t('billing.features.api_access'))
  if (f.mcp_enabled) items.push(t('billing.features.mcp'))
  if (f.design_studio) items.push(t('billing.features.design_studio'))

  if (f.max_posts === -1) items.push(t('billing.features.unlimited_posts'))
  else if (f.max_posts) items.push(t('billing.features.posts', { count: f.max_posts }))

  if (f.max_accounts === -1) items.push(t('billing.features.unlimited_accounts'))
  else if (f.max_accounts) {
    const key = f.max_accounts > 1 ? 'billing.features.accounts_plural' : 'billing.features.accounts'
    items.push(t(key, { count: f.max_accounts }))
  }

  if (f.ai_enabled) {
    items.push(t('billing.features.ai_assistant'))
    if (f.max_ai_tokens === -1) items.push(t('billing.features.unlimited_ai_tokens'))
    else items.push(t('billing.features.ai_tokens', { count: Number(f.max_ai_tokens) || 0 }))
  }
  if (f.recurring) items.push(t('billing.features.recurring'))
  if (f.analytics) items.push(t('billing.features.analytics'))
  return items
}
